import { ReactNode } from 'react';

interface SeoProps {
 title: string;
 description: string;
}

function HeaderTags(props: SeoProps): ReactNode {
 const { title, description } = props;
 return (
  <>
   <title>{title} - Scale Expert</title>
   <meta name="description" content={description} />
   <meta property="og:type" content="website" />
   <meta property="og:title" content={title} />
   <meta property="og:description" content={description} />
  </>
 );
}
export default HeaderTags;
